import { connect, useSelector } from "react-redux";
import selected from "../../../redux-store/actions/selected";
import { Loading } from "../../../components/common";
import { CButton } from "@coreui/react";
import React, { useEffect, useState } from "react";
import StoreListWhere from "../where/StoreListWhere";
import StoreCornerListWhere from "../where/StoreCornerListWhere";

const TouchKeyManage = (props) => {
  const { user } = useSelector((props) => props.account);
  const { cmpCd, brandCd, storeCd } = props.selected;
  const { store } = props;

  const [searchForm, setSearchForm] = useState({});
  const [url, setUrl] = useState("");
  const [page, setPage] = useState(<div />);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log("storeCd : ", storeCd);

    if (storeCd.length > 0) {
        //const host = process.env.REACT_APP_WEB_URL;
      const host = "https://o2posr.spcnetworks.co.kr";
      console.log("###### 터치키 갱신");
      const url = host + "/link/master/touchkey/touchkeyForm.do?cmpCD=" + cmpCd + "&brandCD=" + brandCd + "&storeCD=" + storeCd + "&agencyId=&userId=" + user.userId
      console.log("###### touchkey url :: ", url);
      setPage(<iframe width={"100%"} height={"650"} src={url}/>);
    }
  }, [storeCd]);

  const handleSelect = (code, value) => {
    console.log("code :: ", code, " value :: ", value);
    if (value === "C") {
      setSearchForm((state) => ({
        ...state,
        cmpCd: code
      }));
    } else if (value === "B") {
      setSearchForm((state) => ({
        ...state,
        brandCd: code
      }));
    } else if (value === "S") {
      setSearchForm((state) => ({
        ...state,
        storeCd: code
      }));
    } else if (value === "O") {
      setSearchForm((state) => ({
        ...state,
        cornerCd: code
      }));
    }
  };

  return (
    <div>
      {loading ? <Loading/> : null}
      <StoreCornerListWhere type={"S"} account={props.account} selected={searchForm}
                      onSelect={(c, v) => handleSelect(c, v)}/>
      {page}
    </div>
  );
};

const mapStateToProps = (state) => {
    const { account, store, selected } = state;
    return {
      account, store, selected
    };
  }
;

export default connect(mapStateToProps, null)(TouchKeyManage);
